import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { AuthConfirmFormModal } from '@/Module/Auth/Component';
import { RenderComponents } from '@/Module/Core/Component';
import type { IProps } from '@/Module/Core/Model/DataModel';
import { useAppSelector } from '@/Module/Store/Hook';
const DesktopComponent = dynamic(() => import('./DefaultLayoutDesktop'));
const MobileComponent = dynamic(() => import('./DefaultLayoutMobile'));
const DefaultLayout: FC<IProps> = props => {
  const router = useRouter();
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const isComplete = useAppSelector(state => state.auth.person?.isComplete);
  return <>
      <RenderComponents DesktopComponent={DesktopComponent} MobileComponent={MobileComponent} {...props} data-sentry-element="RenderComponents" data-sentry-source-file="DefaultLayout.tsx" />
      {isLoggedIn && !isComplete && !router.pathname.includes('subscription') && !router.pathname.includes('auth') && <AuthConfirmFormModal />}
    </>;
};
export default DefaultLayout;